<template>
  <div class="location-d">
    <button
      class="location-d__link"
      type="button"
      :class="cityName.length > 15 ? 'location-d__link-truncate' : ''"
      @click="showLocationPopup"
    >
      <icon
        name="Location_16"
        class="location-d__link-icon"
        width="16"
        height="16"
      />
      <span class="location-d__link-text js-delivery-location">
        {{ cityName }}
      </span>
    </button>
    <div v-show="isLocationPopup" class="location-d__popup">
      <button class="location-d__popup-close" @click="hideLocationPopup">
        <icon
          name="close-extra"
          class="location-d__close-icon"
          width="12"
          height="12"
        />
      </button>
      <div class="location-d__popup-title">
        Ваш город —
      </div>
      <div class="location-d__popup-city js-delivery-location">
        {{ cityName }}?
      </div>
      <div class="location-d__popup-buttons">
        <div class="location-d__popup-btn">
          <button-control
            size="small"
            class="_gary _location"
            @click="showCityModal"
          >
            Выбрать другой
          </button-control>
        </div>
        <div class="location-d__popup-btn">
          <button-control
            class="_location js-geo-accept"
            size="small"
            :data-geo-accept-cookie-name="cookieName"
            :data-geo-accept-cookie-true-value="cookieTrueValue"
            :data-geo-accept-cookie-http-host="cookieHttpHost"
            :data-geo-accept-cookie-expires-days="cookieExpiresDays"
            @click="applyLocation"
          >
            Да, всё верно
          </button-control>
        </div>
      </div>
    </div>
    <city-modal
      :is-world-delivery="true"
      :city="{name: cityName}"
      name="city-modal-header"
      @selected="modalSelectedHandler"
    />
  </div>
</template>

<script>
import { ButtonControl } from '@book24/ui-components';

import init from '@/js/helpers/init';
import { getUrlWithParams, setUrl } from '@/js/utils/url';

import GeoAccept from '@/js/widget/GeoAccept';

import Icon from '@/js/vue/Icon';
import CityModal from '@/js/vue/CityModal';

export default {
  components: {
    Icon,
    CityModal,
    ButtonControl,
  },
  props: {
    dataset: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      cityName: this.dataset.cityName,
      cookieName: this.dataset.cookieName,
      cookieTrueValue: this.dataset.cookieTrueValue,
      cookieHttpHost: this.dataset.cookieHttpHost,
      cookieExpiresDays: this.dataset.cookieExpiresDays,
      isLocationPopup: false,
    };
  },
  methods: {
    showLocationPopup() {
      this.isLocationPopup = true;
    },
    hideLocationPopup() {
      this.isLocationPopup = false;
    },
    /**
     * открыть модальное окно города
     */
    showCityModal() {
      this.hideLocationPopup();
      this.$modal.show('city-modal-header');
    },
    /**
     * Применить локацию
     */
    applyLocation() {
      this.hideLocationPopup();
      init('.js-geo-accept', GeoAccept, 'widget', 'GeoAccept');
    },
    /**
     * Действие после выбора города из модалки
     * @params {Object} city - информация о выбранном городе
     */
    modalSelectedHandler({ city }) {
      this.cityName = city.name;
      setUrl(getUrlWithParams({ key: 'location', value: city.location }));
    },
  },
};
</script>
